import { Box } from '@mui/material'
import React from 'react'
import useStyles from './styles/Footer.styles'

const Footer = () => {
    const classes = useStyles()
    return <Box className={classes.footerBox}>© 2022 vytvořeno nexum.cz</Box>
}

export default Footer
